module.exports = __webpack_public_path__ + "img/calendar.c569c45c.svg";